export default __webpack_public_path__ + "static/media/ico_bonusCheckbox_true.d6d938cc.svg";